import { render, staticRenderFns } from "./MagicCubeBlocks.vue?vue&type=template&id=8d14ed0c&scoped=true"
import script from "./MagicCubeBlocks.vue?vue&type=script&lang=js"
export * from "./MagicCubeBlocks.vue?vue&type=script&lang=js"
import style0 from "./MagicCubeBlocks.vue?vue&type=style&index=0&id=8d14ed0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d14ed0c",
  null
  
)

export default component.exports